import MoleculeButtonDropDown from './MoleculeButtonDropDown/MoleculeButtonDropDown';
import MoleculeLogo from './MoleculeLogo/MoleculeLogo';
import MoleculeAvatar from './MoleculeAvatar/MoleculeAvatar';
import MoleculeIconText from './MoleculeIconText/MoleculeIconText';
import MoleculeIconTitle from './MoleculeIconTitle/MoleculeIconTitle';
import MoleculeTdTableWithIcon from './MoleculeTdTableWithIcon/MoleculeTdTableWithIcon';
import MoleculeInput from './MoleculeInput/MoleculeInput';
import MoleculeTable from './MoleculeTable/MoleculeTable';
import MoleculePagination from './MoleculePagination/MoleculePagination';
import MoleculeEditor from './MoleculeEditor/MoleculeEditor';
import MoleculeModal from './MoleculeModal/MoleculeModal';
import MoleculeUpload from './MoleculeUpload/MoleculeUpload';
import MoleculeStepsProgressBar from './MoleculeStepsProgressBar/MoleculeStepsProgressBar';
import MoleculeAffiliationHeader from './MoleculeAffiliationHeader/MoleculeAffiliationHeader';
import MoleculeAffiliationText from './MoleculeAffiliationText/MoleculeAffiliationText';
import MoleculeAffiliationRecap from './MoleculeAffiliationRecap/MoleculeAffiliationRecap';
import MoleculeAffiliationRecapSummary from './MoleculeAffiliationRecapSummary/MoleculeAffiliationRecapSummary';
import MoleculeDetailDocument from "./MoleculeDetailDocument/MoleculeDetailDocument";
import MoleculeAffiliationButton from './MoleculeAffiliationButton/MoleculeAffiliationButton';
import MoleculeCollapse from "./MoleculeCollapse/MoleculeCollapse";
import MoleculeDispenseCheckBox from './MoleculeDispenseCheckBox/MoleculeDispenseCheckBox';
import MoleculeAffiliationOption from './MoleculeAffiliationOption/MoleculeAffiliationOption';
import MoleculeChartLegend from './MoleculeChartLegend/MoleculeChartLegend';
import MoleculeSliderPoint from './MoleculeSliderPoint/MoleculeSliderPoint';

export const ButtonDropDown = MoleculeButtonDropDown;
export const AvatarMolecule = MoleculeAvatar;
export const Logo = MoleculeLogo;
export const IconTextMolecule = MoleculeIconText;
export const IconTitleMolecule = MoleculeIconTitle;
export const TdTableWithIcon = MoleculeTdTableWithIcon;
export const Input = MoleculeInput;
export const Table = MoleculeTable;
export const Pagination = MoleculePagination;
export const Editor = MoleculeEditor;
export const Modal = MoleculeModal;
export const Upload = MoleculeUpload;
export const StepsProgressBar = MoleculeStepsProgressBar;
export const AffiliationHeaderMolecule = MoleculeAffiliationHeader;
export const AffiliationTextMolecule = MoleculeAffiliationText;
export const AffiliationRecapMolecule = MoleculeAffiliationRecap;
export const AffiliationRecapSummaryMolecule = MoleculeAffiliationRecapSummary;
export const DetailDocument = MoleculeDetailDocument
export const AffiliationButtonMolecule = MoleculeAffiliationButton;
export const Collapse = MoleculeCollapse
export const DispenseCheckBox = MoleculeDispenseCheckBox;
export const AffiliationOptionMolecule = MoleculeAffiliationOption;
export const ChartLegendMolecule = MoleculeChartLegend;
export const SliderPoint = MoleculeSliderPoint;
